import { z } from 'zod';

const timeFormatRegex = /^\d{2}:\d{2}$/;

const zTimeString = z.string().superRefine((val, ctx) => {
  if (!timeFormatRegex.test(val)) {
    ctx.addIssue({
      code: z.ZodIssueCode.custom,
      message: 'Поле обязательно для заполнения'
    });
    return;
  }
  const [hoursStr, minutesStr] = val.split(':');
  const hours = Number(hoursStr);
  const minutes = Number(minutesStr);

  if (minutes < 0 || minutes > 59) {
    ctx.addIssue({
      code: z.ZodIssueCode.custom,
      message: 'Минуты должны быть в диапазоне 00-59'
    });
    return;
  }
  if (hours < 0 || hours > 24) {
    ctx.addIssue({
      code: z.ZodIssueCode.custom,
      message: 'Допустимый диапазон: 00:00-24:00'
    });
    return;
  }
  if (hours === 24 && minutes !== 0) {
    ctx.addIssue({
      code: z.ZodIssueCode.custom,
      message: 'Допустимый диапазон: 00:00-24:00'
    });
  }
});

const zTimeStringUntil2359 = z.string().superRefine((val, ctx) => {
  if (!timeFormatRegex.test(val)) {
    ctx.addIssue({
      code: z.ZodIssueCode.custom,
      message: 'Поле обязательно для заполнения'
    });
    return;
  }

  const [hoursStr, minutesStr] = val.split(':');
  const hours = Number(hoursStr);
  const minutes = Number(minutesStr);

  if (minutes < 0 || minutes > 59) {
    ctx.addIssue({
      code: z.ZodIssueCode.custom,
      message: 'Минуты должны быть в диапазоне 00-59'
    });
    return;
  }
  if (hours < 0 || hours > 23) {
    ctx.addIssue({
      code: z.ZodIssueCode.custom,
      message: 'Допустимый диапазон: 00:00–23:59'
    });
  }
});

const zBreakDuration = z.string().superRefine((val, ctx) => {
  if (val === '') return; // пустое валидно
  if (!timeFormatRegex.test(val)) {
    ctx.addIssue({
      code: z.ZodIssueCode.custom,
      message: 'Формат ЧЧ:ММ'
    });
    return;
  }
  const [hoursStr, minutesStr] = val.split(':');
  const hours = Number(hoursStr);
  const minutes = Number(minutesStr);

  if (minutes < 0 || minutes > 59) {
    ctx.addIssue({
      code: z.ZodIssueCode.custom,
      message: 'Минуты должны быть в диапазоне 00-59'
    });
    return;
  }
  if (hours < 0 || hours > 24) {
    ctx.addIssue({
      code: z.ZodIssueCode.custom,
      message: 'Допустимый диапазон: 00:00-24:00 или пустое значение'
    });
    return;
  }
  if (hours === 24 && minutes !== 0) {
    ctx.addIssue({
      code: z.ZodIssueCode.custom,
      message: 'Допустимый диапазон: 00:00-24:00 или пустое значение'
    });
  }
});

const ShiftSchema = z.object({
  personId: z.number().min(1, 'Выберите сотрудника'),
  id: z.number().optional(),
  departmentId: z.number().min(1),
  date: z.string().nonempty('Поле обязательно'),
  workdayStart: zTimeStringUntil2359,
  workdayDuration: zTimeString,
  breakDuration: zBreakDuration,
  guid: z.string().optional(),
  comment: z.string().optional(),
  isTemplate: z.boolean().optional()
});

export default ShiftSchema;
